export enum DocType {
  DESIGN_DOCUMENT = '0',
  METHODOLOGY_DOCUMENT = '1',
  MONITORING_REPORT = '2',
  VERIFICATION_REPORT = '3',
}
